import { Template } from "devextreme-react";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import moment from "moment";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { DateFormat } from "../../helpers/fixcodes";
import Modal from "react-modal";
import { axiosGet, axiosPost } from "../../apis/useAxios";
import { DataGridSkeletonPageSimpleWithTitle } from "../skeleton/GridSkeleton";

export default function ActivityDutyLocationTransferComponent() {
  const [state, setState] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [
    activityDutyLocationTransferDataGridSource,
    setActivityDutyLocationTransferDataGridSource,
  ] = useState(false);
  const refDataGrid = useRef([]);

  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML =
      `Activity Duty Location Transfer`;
  });

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnLoad = async () => {
    try {
      setTimeout(async () => {
        setIsLoading(true);
        await getActivityLocationDutyTransfer();
        setIsLoading(false);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };

  const getActivityLocationDutyTransfer = async () => {
    try {
      const response = await axiosGet(
        `/CrewTypeConfiguration/ActivityDutyLocationTransfer`,
        {
          AirlineCode: sessionStorage.getItem("session_airlineCode"),
          AirportCode: "",
        },
      );
      setActivityDutyLocationTransferDataGridSource(response?.payload ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const renderGridCell = (data) => {};

  return (
    <>
      <style>{`
        /* ── Activity Duty Location Transfer — theme matching sidebar #fff0e6 ── */
        .ca-grid-wrap .dx-header-row td {
          background-color: #fff0e6 !important;
          color: #000000 !important;
          font-size: 0.76rem !important;
          font-weight: 600 !important;
          letter-spacing: 0.02em !important;
          border-color: rgba(255,255,255,0.15) !important;
        }
        .ca-grid-wrap .dx-datagrid-filter-row td {
          background-color: #f5ede4 !important;
        }
        .ca-grid-wrap .dx-datagrid {
          border-radius: 8px !important;
          overflow: hidden !important;
          box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
        }
        .ca-grid-wrap .dx-toolbar {
          background: #fdf7f2 !important;
          border-bottom: 1px solid #e8d5c4 !important;
          padding: 0.35rem 0.6rem !important;
        }
      `}</style>
      {/* <div className="filter-box">
        <div className="card p-2 m-0">
          <div className="row"></div>
        </div>
      </div> */}
      <div className="card ca-grid-wrap">
        <div className="card-body">
          {isLoading && <DataGridSkeletonPageSimpleWithTitle />}
          {!isLoading && (
            <>
              <DataGrid
                ref={refDataGrid}
                dataSource={activityDutyLocationTransferDataGridSource}
                columnAutoWidth={true}
                showColumnLines={true}
                showRowLines={true}
                showBorders={true}
                rowAlternationEnabled={false}
                allowColumnResizing={true}
                onCellPrepared={(e) => {
                  if (e.rowType === "header") {
                    e.cellElement.style.backgroundColor = "#fff0e6";
                    e.cellElement.style.color = "#000000";
                  }
                }}
                onToolbarPreparing={(e) => {
                  e.toolbarOptions.items.unshift({
                    location: "after",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      onClick: async (e) => {
                        try {
                          refDataGrid.current.instance.beginCustomLoading();
                          e.component.option("icon", "fas fa-spinner fa-spin");
                          await new Promise((resolve) =>
                            setTimeout(resolve, 500),
                          );
                          await getActivityLocationDutyTransfer();
                          refDataGrid.current.instance.endCustomLoading();
                          e.component.option("icon", "refresh");
                        } catch (error) {
                          console.log(error);
                        }
                      },
                    },
                  });
                }}
              >
                {/* <Column
                  dataField="id"
                  caption=""
                  allowFiltering={false}
                  allowSorting={false}
                  allowSearch={false}
                  width={"auto"}
                  //alignment={"left"}
                  cellRender={renderGridCell}
                /> */}
                <Column
                  dataField="airlineCode"
                  caption="Airline"
                  allowSorting={false}
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  width={100}
                  alignment={"center"}
                />
                <Column
                  dataField="airportCode"
                  caption="Airport"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="locationCode"
                  caption="Location Code"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="crewTypeCategory"
                  caption="Crew Type Stay For"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="transporterName"
                  caption="Transport"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="transporterEmail"
                  caption="Email"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="transporterPhoneNo"
                  caption="Phone"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="singleTripVehicleType"
                  caption="Single Trip Vehicle Type"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="pilotVehicleType"
                  caption="Pilot Vehicle Type"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="flightAttendantVehicleType"
                  caption="Flight Attendant Vehicle Type"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="wefDate"
                  caption="Wef Date"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                  dataType="datetime"
                  format={DateFormat.DateNorthFormat}
                />
                <Column
                  dataField="endDate"
                  caption="End Date"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                  dataType="datetime"
                  format={DateFormat.DateNorthFormat}
                />
                <Column
                  dataField="effectedDate"
                  caption="Effected Date"
                  allowSearch={true}
                  headerFilter={{ allowSearch: true }}
                  allowFiltering={true}
                  allowSorting={true}
                  dataType="datetime"
                  format={DateFormat.DateNorthFormat}
                />
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={20} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 20, 50]}
                  showInfo={true}
                  visible={true}
                />
                <SearchPanel
                  visible={true}
                  highlightCaseSensitive={true}
                  width={240}
                  placeholder="Search..."
                />
                <Export
                  enabled={true}
                  allowExportSelectedData={false}
                  fileName="ActivityDutyLocationTransfer"
                />
              </DataGrid>
            </>
          )}
        </div>
      </div>
    </>
  );
}
